import { render, staticRenderFns } from "./WpBottomLeft.vue?vue&type=template&id=56ce43c4&"
import script from "./WpBottomLeft.vue?vue&type=script&lang=js&"
export * from "./WpBottomLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports